<script>
	import { Router, createRouter } from "@roxi/routify";
	import { routes } from "../.routify/routes.default.js";
	import { waitLocale, format } from "svelte-i18n";
	import Spinner from "./components/spinner.svelte";
	import { token } from "./routes/user/user.state.svelte.js";
	import Chart from "chart.js/auto";
	import "./services/analytics.js";
	import "./v2-App.css";
	import "admin-lte/dist/css/adminlte.css";

	import "toastr/build/toastr.css";
	import "sweetalert2/dist/sweetalert2.css";
	import "select2/dist/css/select2.min.css";
	import "@fortawesome/fontawesome-free/css/all.css";

	import "bootstrap/dist/js/bootstrap.bundle.min.js";
	import "admin-lte/dist/js/adminlte.js";

	import "./i18n.js";

	const router = createRouter({ routes });

	// show "no data" message
	Chart.register({
		id: "custom_after_draw",
		afterDraw: (chart) => {
			if (chart.data.datasets[0].data.length === 0) {
				// No data is present
				let ctx = chart.ctx;
				let width = chart.width;
				let height = chart.height;
				chart.clear();

				ctx.save();
				ctx.textAlign = "center";
				ctx.textBaseline = "middle";
				ctx.font = "normal 20px 'Montserrat-bold'";
				ctx.fillStyle = "black";
				//ctx.fillText(chart.options.title.text, width / 2, 18);
				ctx.fillText($format("chart_no_data"), width / 2, height / 2);
				ctx.restore();
			}
		},
	});

	//runs when token.access_token value gets updated
	$effect(() => {
		if (!token.access_token) {
			return localStorage.removeItem("access_token");
		} else {
			localStorage.setItem("access_token", token.access_token);
		}
	});
</script>

{#await waitLocale()}
	<Spinner />
{:then success}
	<Router {router} />
{/await}
